<header class="dialog-header">
  <img src="/img/logo-alimentium-small.png" alt="Alimentium" width="200" class="logo logo--light">
  <img src="/img/logo-alimentium-white-small.png" alt="Alimentium" width="200" class="logo logo--dark">

  <h2 mat-dialog-title>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.TITLE' | translate }}</h2>
</header>

<mat-stepper [linear]="isLinear" [disableRipple]="true" #stepper>

  <!-- Step 1 -->
  <mat-step [stepControl]="firstFormGroup">
    <ng-template matStepLabel>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_1.LABEL' | translate }}</ng-template>
    <div class="lottie-animation">
      <ng-lottie [options]="options" width="150px" height="150px"></ng-lottie>
    </div>
    <form id="first-form" [formGroup]="firstFormGroup">
      <p id="welcome-message">{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_1.MESSAGE1' | translate }}
        <br><br>
        {{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_1.MESSAGE2' | translate }}
      </p>
      <label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_1.SELECT-LANG' | translate }}</label>
      <mat-form-field class="alim-mat-form-field" appearance="outline">
        <mat-label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_1.LANG' | translate }}</mat-label>
        <mat-select formControlName="language" (selectionChange)="switchLanguage($event.value);" required>
          <mat-option *ngFor="let lang of languages" [value]="lang.code">
            <span class="fi fi-{{ lang.code | flagClass }}"></span>
            {{ lang.name | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="stepper-buttons">
        <button type="button" mat-flat-button color="primary" matStepperNext [disabled]="!firstFormGroup.valid">
          <mat-icon>arrow_forward</mat-icon>
          {{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <!-- Step 2 -->
  <mat-step [stepControl]="secondFormGroup">
    <ng-template matStepLabel>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_2.LABEL' | translate }}</ng-template>
    <form [formGroup]="secondFormGroup">
      <label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_2.WHATS-YOUR-NAME' | translate }}</label>
      <mat-form-field class="alim-mat-form-field" appearance="outline">
        <mat-label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_2.NAME' | translate }}</mat-label>
        <input matInput formControlName="name" placeholder="Ex. Juan Pérez" required>
      </mat-form-field>
      <div class="stepper-buttons">
        <button type="button" mat-flat-button color="primary" matStepperNext [disabled]="!secondFormGroup.valid">
          <mat-icon>arrow_forward</mat-icon>
          {{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <!-- Step 3 -->
  <mat-step [stepControl]="thirdFormGroup">
    <ng-template matStepLabel>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_3.LABEL' | translate }}</ng-template>
    <form [formGroup]="thirdFormGroup">
      <label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_3.WHAT-YOUR-JOB' | translate }}</label>
      <mat-chip-set>
        <mat-chip-option *ngFor="let profile of profiles" [value]="profile.code"
          [selected]="thirdFormGroup.get('profile')!.value === profile.code"
          [disabled]="thirdFormGroup.get('profile')!.value === profile.code"
          (click)="thirdFormGroup.get('profile')?.setValue(profile.code)">
          {{ profile.name | translate }}
        </mat-chip-option>
      </mat-chip-set>
      <div class="additional-info" *ngIf="thirdFormGroup.get('profile')!.value == 0">
        <label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_3.SELECT-YOUR-PROFILE' | translate }}</label>
        <mat-form-field class="alim-mat-form-field" appearance="outline">
          <mat-label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_3.PROFILE' | translate }}</mat-label>
          <input matInput formControlName="newProfile" placeholder="Ex. Diseñador">
        </mat-form-field>
      </div>
      <div class="stepper-buttons">
        <button type="button" mat-flat-button color="primary" matStepperNext [disabled]="!thirdFormGroup.valid">
          <mat-icon>arrow_forward</mat-icon>
          {{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <!-- Step 4 -->
  <mat-step [stepControl]="fourthFormGroup">
    <ng-template matStepLabel>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_4.LABEL' | translate }}</ng-template>
    <form [formGroup]="fourthFormGroup">
      <!-- <label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_4.WORK-WITH-PRODUCT-DATA' | translate }}</label>
      <mat-form-field class="alim-mat-form-field" appearance="outline">
        <mat-label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_4.PRODUCT-DATA' | translate }}</mat-label>
        <mat-select formControlName="gonnaWorkWithProductsData" required>
          <mat-option value="true">{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_4.YES' | translate }}</mat-option>
          <mat-option value="false">{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_4.NO' | translate }}</mat-option>
        </mat-select>
      </mat-form-field> -->
      <div class="additional-info" *ngIf="fourthFormGroup.get('gonnaWorkWithProductsData')?.value === 'true'">
        <label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_4.LANG-FOR-PRODUCT-DATA' | translate }}</label>
        <mat-form-field class="alim-mat-form-field" appearance="outline">
          <mat-label>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_4.LANGUAGE' | translate }}</mat-label>
          <mat-select formControlName="language" required>
            <mat-option *ngFor="let lang of companyActiveLanguages" [value]="lang.code">
              <span class="fi fi-{{ lang.code | flagClass }}"></span>
              {{ lang.translatedName | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="stepper-buttons">
        <button type="button" mat-flat-button color="primary" matStepperNext [disabled]="!fourthFormGroup.valid">
          <mat-icon>arrow_forward</mat-icon>
          {{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.NEXT' | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <!-- Step 5 -->
  <mat-step [stepControl]="fifthFormGroup">
    <ng-template matStepLabel>{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_5.LABEL' | translate }}</ng-template>
    <form [formGroup]="fifthFormGroup">
      <label id="profile-target-question">{{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_5.START' | translate }}</label>
      <mat-radio-group formControlName="target" aria-labelledby="profile-target-question">
        <div class="destino-card" *ngFor="let target of targets"
          [class.selected]="fifthFormGroup.get('target')?.value === target.value"
          (click)="fifthFormGroup.get('target')?.setValue(target.value)">
          <mat-radio-button [value]="target.value"></mat-radio-button>
          <div class="destino-info">
            <div class="destino-title">{{ target.title | translate }}</div>
            <div class="destino-desc">{{ target.description | translate }}</div>
          </div>
        </div>
      </mat-radio-group>
      <div class="stepper-buttons">
        <button type="button" mat-fab extended color="primary" class="go-button" (click)="save()" [disabled]="!fifthFormGroup.valid">
          <mat-icon>check</mat-icon>
          {{ 'STANDALONE-COMPONENTS.PROFILE-STEPPER.STEP_5.GO' | translate }}
          <span>
            🚀
          </span>
        </button>
      </div>
    </form>
  </mat-step>

</mat-stepper>
